import React from 'react';
import PropTypes from 'prop-types';
import { CompactPicker } from 'react-color';
import styled from 'styled-components';

import WithPopoverClick from 'shared-assets/components/WithPopoverClick';

const Wrapper = styled.div`
  border: 1px solid rgb(208, 208, 208);
  border-radius: 0.25rem;
  display: inline-block;
  height: 2rem;
  width: 100%;
  box-shadow: 0 0 0 3px white inset;
  position: relative;
`;

class ColorPicker extends React.Component {
  static defaultProps = {
    onChange: () => {},
    style: undefined,
  };

  static propTypes = {
    color: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    style: PropTypes.object,
  };

  static getDerivedStateFromProps(props, state) {
    /* Only updates the state.color if the props has changed */
    if (
      !!props.color &&
      props.color !== state.prevPropColor &&
      props.color !== state.color
    ) {
      return { color: props.color, prevPropColor: props.color };
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      prevPropColor: null,
    };
  }

  onColorChanged = event => {
    this.setState({ color: event.hex }, () => {
      this.props.onChange(event);
    });
  };

  render() {
    return (
      <WithPopoverClick
        render={
          <div data-testid="colorPicker">
            <CompactPicker
              id="compactPicker"
              color={this.state.color}
              onChangeComplete={this.onColorChanged}
            />
          </div>
        }
      >
        <Wrapper
          data-testid="colorPickerWrapper"
          style={{ ...this.props.style, backgroundColor: this.state.color }}
        />
      </WithPopoverClick>
    );
  }
}

export default ColorPicker;
